<!--下单-->
<template>
  <div class="bg-gray">
    <div class="form-content">
        <el-form
            :model="formData"
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="name"
                            :rules="[
    ]"
              >
                <el-input
                    readonly
                    type="text"
                    placeholder="请填入报名人员姓名"
                    v-model="formData.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号" prop="num"
                            :rules="[
    ]"
              >
                <el-input
                    readonly
                    type="text"
                    placeholder="请输入身份证号"
                    v-model="formData.num"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" v-if="false">
              <el-form-item label="是否连考"
                            :rules="[
    ]">
                <el-switch
                    v-model="formData.is_exam_continue"
                    @change="onLiankaoChange"
                    active-text="是"
                    inactive-text="否"
                    active-color="#409EFF"
                    inactive-color="#ddd"
                >
                </el-switch>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="报考星级" prop="grade">
                <el-radio-group v-model="formData.grade">
                  <el-radio :label="item" v-for="item in gradeSelectColumns" :key="item">{{ item }}</el-radio>
                </el-radio-group>
                <div class="form-label-desc" >已付款禁止修改等级</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="添加证件照片(2寸)" prop="pic">
                <PicUploader :fileList="formData.pic" :limit="1"></PicUploader>
                <div class="form-label-desc">上传2寸免冠照,此照片用于证书粘贴打印</div>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="衣服尺码" prop="csize"
                            :rules="formData.grade.indexOf('红') != -1 ? [
      { required: true, message: '请输入尺码', trigger: 'blur' },
    ] : []"
              >
                <el-input
                    type="text"
                    placeholder="请输入尺码"
                    v-model="formData.csize"
                ></el-input>
                <div class="form-label-desc mt10 cp" @click="cSizeShow=true">查看衣服尺码表</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="鞋  码" prop="footsize"
                            :rules="formData.grade.indexOf('红') != -1 ? [
      { required: true, message: '请输入鞋码', trigger: 'blur' },
    ] : []"
              >
                <el-input
                    type="text"
                    placeholder="请输入鞋码"
                    v-model="formData.footsize"
                ></el-input>
                <div class="form-label-desc mt10 cp" @click="fSizeShow=true">查看鞋码表</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="购买考级服"
                            :rules="[
    ]">
                <el-switch
                    v-model="formData.buyc"
                    :disabled="formData.pay_status==2"
                    active-text="是"
                    inactive-text="否"
                    :active-value="1" :inactive-value="2"
                    active-color="#409EFF"
                    inactive-color="#ddd"
                >
                </el-switch>
                <div class="form-label-desc" v-if="formData.pay_status==2">已付款禁止修改</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="购买考级鞋"
                            :rules="[
    ]">
                <el-switch
                    v-model="formData.buys"
                    :disabled="formData.pay_status==2"
                    active-text="是"
                    inactive-text="否"
                    :active-value="1" :inactive-value="2"
                    active-color="#409EFF"
                    inactive-color="#ddd"
                >
                </el-switch>
                <div class="form-label-desc" v-if="formData.pay_status==2">已付款禁止修改</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="家长姓名" prop="famliy_name"
                            :rules="[ { required: true, message: '请输入家长姓名', trigger: 'blur' }]"
              >
                <el-input
                    type="text"
                    placeholder="请输入家长姓名"
                    v-model="formData.famliy_name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号码" prop="famliy_num"
                            :rules="[ { required: true,validator: validator.idCard, message: '请输入正确的身份证号', trigger: 'blur' }]"
              >
                <el-input
                    type="text"
                    placeholder="请输入正确的身份证号"
                    v-model="formData.famliy_num"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="phone"
                            :rules="[ { required: true,validator: validator.phone, message: '请输入正确的手机号', trigger: 'blur' }]"
              >
                <el-input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="formData.phone"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col class="footer-button">
              <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
              </el-button>
              <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
            </el-col>
          </el-row>
        </el-form>




        <el-dialog :visible.sync="cSizeShow" title="衣服尺码表">
          <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%"/>
        </el-dialog>
        <el-dialog :visible.sync="fSizeShow" title="鞋码表">
          <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
          <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)" style="width: 100%"/>
        </el-dialog>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.shop-name {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 27px;
  margin-top: 20px;
  padding: 0 15px;
}

.shop-address {
  height: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 13px;
  margin-top: 5px;
  padding: 10px 15px 20px;
  /*border-bottom: 1px solid rgba(0, 0, 0, .1);*/
}

.delivery-times {
  margin-top: 10px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
}

.business-shop-info {
  /*width: 6.81rem;*/
  /*height: 2.66rem;*/
  border-radius: 7px;
  margin-bottom: 0;
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: -48px;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff center;
  background-size: 10px;
}

.check-header {
  width: 100%;
  height: 200px;
  background: url(../../../assets/images/bg-qcxj-index.png) no-repeat center;
  background-size: 100%;
  position: relative;
}

</style>

<script>
import {Field, Notify, Toast, Popup, Picker, Radio, RadioGroup, Dialog, ImagePreview} from "vant";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: "ExameApplJoin",
  components: {
    [Field.name]: Field,
    Notify,
    Dialog,
    Radio,
    RadioGroup,
    Popup,
    PicUploader,
    [ImagePreview.Component.name]: ImagePreview.Component,
    Toast,
    Picker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      isSubmit: false,
      loginShow: false,
      cSizeShow: false,
      fSizeShow: false,
      confirmShow: false,
      id: this.$route.query.id,
      gradeColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫'],
      gradeSelectColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫'],
      // 红橙、红橙黄、红橙黄绿、橙黄、橙黄绿、黄绿
      gradeLiankaoColumns: ['红', '橙', '黄', '绿', '青', '蓝', '紫', '红橙', '红橙黄', '红橙黄绿', '橙黄', '橙黄绿', '黄绿'],
      cSizePicList: ['https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://bc2026.oss-ap-southeast-1.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
      showGradePicker: false,
      showNumTypePicker: false,
      message: "",
      formData: {
        needLoadingIndicator: true,
        gradeindex: 0,
        grade: '',
        csize: '',
        numTypeName: '身份证',
        numtype: 1,
        kaoji_id: this.$route.query.kaoji_id,
        share_id: this.$route.query.share_id,
        name: '',
//                    num:'362323198807150036',
//                    pic:[{"uid":"vc-upload-1588058680174338","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-28/1588058680174338.png","name":" bg-doing.png","save_name":"h5/2020-04-28/1588058680174338.png"}],
        pic: [],
//                    height:1,
//                    weight:2,
//                    footsize:3,
//                    famliy_name:'李',
//                    famliy_num:'320101197301011111',
//                    phone:'15177772222',
      },
      numTypeColumns: ['身份证', '护照'],
      row: {},
      warnings: [],
      starType: '',
      saveLoading: false,

    };
  },
  watch: {},

  filter: {},
  mounted() {
    document.title = "申报人员详情";
    this.fetch();
  },
  destroyed() {
  },
  methods: {
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.numtype = index + 1;
      this.showNumTypePicker = false;
    },
    onGradeConfirm(value, index) {
      this.formData.grade = value;
      this.formData.gradeindex = index + 1;
      this.showGradePicker = false;
    },
    onLiankaoChange(value) {
      console.log(value)
      if(value) {
        this.gradeSelectColumns = this.gradeLiankaoColumns
      } else {
        this.gradeSelectColumns = this.gradeColumns
      }
    },
    fetch() {
      let that = this;
      that.$api.get('/api/qcxj/kaojiMemberDetail', {
        id : that.id,
        share_id: that.share_id,
      }, (res) => {
        that.formData = res.data;
        that.formData.gradeindex = that.gradeColumns.indexOf(that.formData.grade)+1;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    submitForm2(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          // if (that.formData.heying.length == 0) {
          //   this.$message.warning('请上传队伍照片');
          //   return
          // }
          for (let field in that.formData) {

          }
          that.saveLoading = true;

          that.$api.post('/api/qcxj/checkApplyNameNum', {
            name: that.formData.name,
            num: that.formData.num,
            numtype: that.formData.numtype,
          }, (res) => {
            if (res.data) {
              that.formData.height = res.data.height;
              that.formData.weight = res.data.weight;
              that.formData.footsize = res.data.footsize;
              that.formData.pic = res.data.pic;
              that.formData.famliy_name = res.data.famliy_name;
              that.formData.famliy_num = res.data.famliy_num;
              that.formData.phone = res.data.phone;
            }
            that.isSubmit = true;
            that.saveLoading = false;
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });


    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/qcxj/checkApplyNameNum', {
        name: that.formData.name,
        num: that.formData.num,
        numtype: that.formData.numtype,
      }, (res) => {
        if (res.data) {
          that.formData.height = res.data.height;
          that.formData.weight = res.data.weight;
          that.formData.footsize = res.data.footsize;
          that.formData.pic = res.data.pic;
          that.formData.famliy_name = res.data.famliy_name;
          that.formData.famliy_num = res.data.famliy_num;
          that.formData.phone = res.data.phone;
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onConfirm(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (that.formData.pic.length == 0) {
          Toast.fail('请上传证件照');
          return
        }
        if (!that.formData.grade) {
          Toast.fail('请选择星级');
          return
        }
      }
      this.confirmShow = true;
    },

    submitForm(formName) {

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      that.$refs[formName].validate((valid) => {
        if (valid) {
          for (let field in that.formData) {
            // if(that.formData.pic.length==0){
            //     Toast.fail('请上传证件照');
            //     return
            // }
            // if (!that.formData.grade) {
            //   this.$message.warning('请选择星级');
            //   return
            // }
          }
          that.saveLoading = true;
          that.$api.post('/api/qcxj/applyMemberEdit', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('修改成功');
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });


    },

    onConfirmSubmit() {
      let that = this;
      that.saveLoading = true;
      that.$api.post('/api/qcxj/applyMemberAdd', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('报名成功');

        setTimeout(function () {
          rbLink({
            name: '',
            query: {}
          }, 'back')

        }, 500);

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
};
</script>



// WEBPACK FOOTER //
// ExameApplyMemberDetail.vue?daddc07e